
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SowingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sowing"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cohortId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shipId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seedType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originParcelId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fishingArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mziArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seedYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brutoWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nettoWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tarra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bustal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stukstal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":301}};
    doc.loc.source = {"body":"fragment SowingFragment on Sowing {\n    id\n    cohortId\n    shipId\n    date\n    duration\n    seedType\n    originLocation\n    originType\n    originParcelId\n    fishingArea\n    mziArea\n    seedYear\n    brutoWeight\n    nettoWeight\n    tarra\n    bustal\n    stukstal\n    notes\n    createdAt\n    updatedAt\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SowingFragment"] = oneQuery(doc, "SowingFragment");
        
